import React from 'react';
import { Footer } from '../components/Chrome';
import { APP_STORE_URL, PLAY_STORE_URL } from '../components/GetTheApp';
import { usePageMeta } from '../usePageMeta';

/**
 * longreads.me itself has no index of authors — it is a destination for links
 * people share, not a directory to browse. So the root explains what landed
 * them here and points at the app.
 */
function Landing() {
  usePageMeta(
    'Long reads',
    'Blogs, journals and serials — a reading home, published entry by entry.'
  );

  return (
    <div className="app">
      <main className="landing">
        <div className="landing-mark">
          lr<span>.</span>
        </div>
        <h1>Writing that goes past a caption.</h1>
        <p>
          Long reads is where blogs, journals, serials and books live — published
          entry by entry, read at your own pace.
        </p>
        <p>
          Every author has a page here at <strong>longreads.me/username</strong>.
          Reading is open to anyone; writing, saving and subscribing happen in the app.
        </p>
        <div className="landing-actions">
          <a className="getapp-btn" href={APP_STORE_URL} target="_blank" rel="noreferrer">
            Download on the App Store
          </a>
          <a className="getapp-btn is-secondary" href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
            Get it on Google Play
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Landing;
